import React from "react";
import Footer from "./Footer";
import "./Page.scss";
import classNames from "classnames";
import { withDefaults } from "../../utils/withDefaults";

export interface PageProps {
  showFooter?: boolean;
  showHeader?: boolean;
  children?: React.ReactNode;
}

export default function Page(incomingProps: PageProps) {
  const { showFooter, children, showHeader } = withDefaults(incomingProps, pageDefaultProps);

  return (
    <div className={classNames("page", showHeader ? "show-header" : null)}>
      {children}
      {showFooter ? <Footer /> : null}
    </div>
  );
}

const pageDefaultProps = {
  showFooter: true,
  showHeader: true
};
